import React, { useEffect }  from "react";
import { connect } from "react-redux";
import Card from "components/card";
import { Form } from 'antd';
import RegisterAnimalFields from "./RegisterAnimalFields";
import { 
	getFarmAnimalDetails, doFarmAnimalCreate, doFarmAnimalUpdate 
} from "../../../../redux/farmanimal/farmAnimalState";
import { useForm } from 'antd/lib/form/Form';
import CrudButtons from "components/button/crudbuttons";
import { FormatDateValue } from "../../../../utils/index";

const RegisteredAnimalsForm = ({getRecord, doCreate, doUpdate, recordData, requesting, success, userDetails, ...props}) => {
	const { recordId, mode } = props;  	
	const [form] = useForm();
	
	useEffect(() => {		
		getRecord(recordId);
	}, [recordId, getRecord]);
	
	useEffect(() => {
		if(recordData){
			const { birthdate, ...restData } = recordData;
			const initialValues = {
				birthdate: birthdate ? FormatDateValue(birthdate) : null,
				...restData				
			};
			form.setFieldsValue(initialValues);
		}
	}, [recordData, form]);
	
	const onSubmit = (formData) => {	
		try {
			formData.unit_count = formData.unit_count === false ? 0 : formData.unit_count;
			formData.birthdate = formData.birthdate ? formData.birthdate.format('YYYY-MM-DD') : null;
			recordData.id > 0 ? doUpdate(formData): doCreate(formData); 
		} catch (error) {
			console.error('Save failed:', error);
		}
	};

	return (
		<Card extra={"w-full h-full p-4"}>
			<Form form={form} className="p-4 bg-white rounded-md dark:bg-intsamis-900"
				layout="vertical"
				onFinish={onSubmit}
			>   
				<RegisterAnimalFields recordData={recordData} mode={mode} form={form} isAdmin={true}/>

				<CrudButtons baseRoute="/console/registered-animals" mode={mode} recordId={recordId}/>
			</Form>	 	
		</Card>
    );
};

const mapStateToProps = (state) => ({
	recordData: state.farmAnimal.details?.data,
	requesting: state.farmAnimal.details?.requesting,
	success: state.farmAnimal.details?.success,
	userDetails: state.farmAnimal.details?.data,
});

const mapDispatchToProps = (dispatch) => ({
	getRecord: (id) => dispatch(getFarmAnimalDetails(id)),
	doCreate: (data) => dispatch(doFarmAnimalCreate(data)),
	doUpdate: (data) => dispatch(doFarmAnimalUpdate(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(RegisteredAnimalsForm);